@if (tasks.length > 0) {
  <h2 class="mt-1">Tasks</h2>
  <ul class="task-list">
    @for (task of tasks; track task) {
      <li class="page-section task-section">
        <div class="mt-1 header-row">
          <div class="header-text">
            <h3 class="credential-name">{{ task.name }}</h3>
            <p>{{ task.formType }} - {{ task.sentDate | date }}</p>
          </div>
          <div>
            <button
              mat-flat-button
              color="primary"
              class="mb-1 primary-button"
              (click)="startSubmission(task)"
              [attr.aria-label]="'Submit response for ' + task.name"
            >
              Go <mat-icon iconPositionEnd>arrow_forward</mat-icon>
            </button>
            @if (task.deadline) {
              <p class="task-deadline">before {{ task.deadline | date }}</p>
            }
          </div>
        </div>
      </li>
    }
  </ul>
}
